const setDateTimeout = (fn, d) => {
  var t = d.getTime() - (new Date()).getTime()
  if (t < 0) fn()
  return setTimeout(fn, t)
}

export default setDateTimeout
